// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateMarketingProfileMemberSocialAccounts(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MarketingProfileMemberSocialAccountsUpdated"]);
}

var variablesConverter = {"updateMarketingProfileMemberSocialAccountsInput":{"socialAccounts":{"r":"marketingProfileSocialAccountsInput"}},"marketingProfileSocialAccountsInput":{},"__root":{"input":{"r":"updateMarketingProfileMemberSocialAccountsInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateMarketingProfileMemberSocialAccounts_MarketingProfileMemberSocialAccountsUpdated_member":{"f":""},"updateMarketingProfileMemberSocialAccounts":{"u":"response_updateMarketingProfileMemberSocialAccounts"}}};

var wrapResponseConverterMap = {
  response_updateMarketingProfileMemberSocialAccounts: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateMarketingProfileMemberSocialAccounts_MarketingProfileMemberSocialAccountsUpdated_member":{"f":""},"updateMarketingProfileMemberSocialAccounts":{"u":"response_updateMarketingProfileMemberSocialAccounts"}}};

var responseConverterMap = {
  response_updateMarketingProfileMemberSocialAccounts: unwrap_response_updateMarketingProfileMemberSocialAccounts
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMarketingProfileMemberSocialAccountsFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberSocialAccountsUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMarketingProfileMemberSocialAccountsFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberSocialAccounts",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingProfileSocialAccounts",
                    "kind": "LinkedField",
                    "name": "socialAccounts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "twitter",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "facebook",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "instagram",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "linkedIn",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "youTube",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tikTok",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "yelp",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberSocialAccountsUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24f8f16ec4aa18e9cf8112a288930792",
    "id": null,
    "metadata": {},
    "name": "EditMarketingProfileMemberSocialAccountsFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditMarketingProfileMemberSocialAccountsFormMutation(\n  $input: UpdateMarketingProfileMemberSocialAccountsInput!\n) {\n  updateMarketingProfileMemberSocialAccounts(input: $input) {\n    __typename\n    ... on MarketingProfileMemberSocialAccountsUpdated {\n      member {\n        ...EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember\n        nodeId\n      }\n    }\n  }\n}\n\nfragment EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember on MarketingProfileMember {\n  id\n  firstName\n  displayName\n  socialAccounts {\n    twitter\n    facebook\n    instagram\n    linkedIn\n    youTube\n    tikTok\n    yelp\n  }\n}\n"
  }
};
})());

var wrap_response_updateMarketingProfileMemberSocialAccounts = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateMarketingProfileMemberSocialAccounts = unwrap_response_updateMarketingProfileMemberSocialAccounts;
exports.wrap_response_updateMarketingProfileMemberSocialAccounts = wrap_response_updateMarketingProfileMemberSocialAccounts;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
